import React from "react";
import { MenuItem } from "./pos.types";

export const getPizzaIcon = (
  type: "left" | "right" | "whole",
  isSelected: boolean,
): React.ReactElement => {
  const fillColor = isSelected ? "currentColor" : "black";
  const emptyColor = isSelected ? "transparent" : "white";

  if (type === "left") {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className="w-4 h-4"
      >
        <circle
          cx="8"
          cy="8"
          r="6.5"
          stroke={fillColor}
          strokeWidth="1.5"
          fill={emptyColor}
        />
        <path d="M8 1.5 L8 14.5" stroke={fillColor} strokeWidth="1" />
        <path
          d="M1.5 8 A6.5 6.5 0 0 1 8 1.5 L8 14.5 A6.5 6.5 0 0 1 1.5 8"
          fill={fillColor}
        />
      </svg>
    );
  }
  if (type === "right") {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className="w-4 h-4"
      >
        <circle
          cx="8"
          cy="8"
          r="6.5"
          stroke={fillColor}
          strokeWidth="1.5"
          fill={emptyColor}
        />
        <path d="M8 1.5 L8 14.5" stroke={fillColor} strokeWidth="1" />
        <path
          d="M14.5 8 A6.5 6.5 0 0 1 8 14.5 L8 1.5 A6.5 6.5 0 0 1 14.5 8"
          fill={fillColor}
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className="w-4 h-4"
    >
      <circle
        cx="8"
        cy="8"
        r="6.5"
        stroke={fillColor}
        strokeWidth="1.5"
        fill={fillColor}
      />
    </svg>
  );
};

export const PizzaIcons = {
  left: getPizzaIcon("left", false),
  right: getPizzaIcon("right", false),
  whole: getPizzaIcon("whole", false),
};

export const computeFreeToppingDiscount = (
  item: MenuItem,
  selections: Record<string, number | string>,
): number => {
  let total = 0;
  for (const group of item.customize) {
    if (group.required || group.multiple) continue;
    const freeToppings = group.noOfFreeToppings ?? 0;
    if (!freeToppings) continue;
    let freeRemaining = freeToppings;
    for (const choice of group.choices) {
      if (freeRemaining <= 0) break;
      if (choice.default) continue;
      const key = `${group.name}|||${choice.label}`;
      const qty = Number(selections[key] || 0);
      if (qty > 0) {
        const freeQty = Math.min(qty, freeRemaining);
        total += (choice.price || 0) * freeQty;
        freeRemaining -= freeQty;
      }
    }
  }
  return total;
};

export const createSlug = (name: string | null | undefined): string => {
  if (!name) return "";
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim();
};

export const isHalfHalfEligibleGroup = (
  group: any,
  isHalfHalfPizza: boolean,
): boolean => {
  return isHalfHalfPizza && Boolean(group?.showPortionSelector);
};
